/** ดึงชื่อไฟล์จาก URL (segment สุดท้าย) ถ้าไม่มีใช้ชื่อ fallback ตาม index */
export const fileNameFromUrl = (url: string, index: number): string => {
  const lastSegment = url.split('/').pop()
  return lastSegment ? decodeURIComponent(lastSegment) : `ไฟล์แนบ ${index + 1}`
}
